<!-- 商品信息 -->
<template>
    <div class="market">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!-- <div class="left search flex flex-align-center" style="width:120px;">
                            <input type="text" class="left" placeholder="请输入商品名" v-model="goods">
                            <i class="el-icon-search" @click="searchGoods"></i>
                            <ul class="details_search" @click.stop="" :style="{display:(goodCheckArr[0]?'block':'none')}">
                                <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                                    <div class="iconInner"></div>
                                </div>
                                <li v-for="item in goodCheckArr" @click="selSearchGood(item,'search')">
                                    <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                                </li>
                            </ul>
                        </div> -->
                        <div class="fliter type">
                            分类选择：
                            <el-select v-model="fliter_type" style="width:120px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div class="left searchBtn" style="padding-left:10px;">
                            <button type="button" @click="fliterGoods" style="padding: 0 10px">筛选</button>
                        </div>
                        <div class="right searchBtn cart" >
                            <button type="button"  @click="addGoods">
                                <i class="iconfont icon-gouwuche"></i>
                                <span>购物车</span>
                                <span class="cart-count" v-if="seledGoodCount>0">
                                   <b>{{seledGoodCount}}</b>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:4%">序号</th>
                                <th style="width:10%">商品</th>
                                <th style="width:10%">商品名</th>
                                <th style="width:8%">分类</th>
                                <th style="width:8%">规格</th>
                                <th style="width:6%">单价</th>
                                <th style="width:6%">备注</th>
                                <th style="width:6%">购买数量</th>
                                <th style="width:12%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:vipData.length > 6}">
                                    <tr v-for="(item,idx) in vipData">
                                        <td style="width:4%" v-text="item.id?(idx+1):''"></td>
                                        <td style="width:10%" class="img" title="点击查看大图">
                                            <div class="img_box" v-if='item.id' @click="bigImg(item)">
                                                <img style="cursor:pointer;" :src="item.image" alt="">
                                            </div>
                                        </td>
                                        <td style="width:10%" v-text="item.productName" :title="item.productName"></td>
                                        <td style="width:8%" v-text="item.productTypeName"></td>
                                        <td style="width:8%" v-text="item.spec"></td>
                                        <td style="width:6%" v-text="item.amount"></td>
                                        <!-- <td style="width:6%"><span class="notice" @click="notice(item)">{{item.id?(item.notice?"查看备注":"暂无备注"):""}}</span></td> -->
                                        <td style="width:6%"><span :class="item.notice?'notice active':'notice'">{{item.id?(item.notice?item.notice:"暂无备注"):""}}</span></td>
                                        <td style="width:6%" class="add-count">
                                            <input type="text" v-if="item.id" v-model="item.count" />
                                        </td>
                                        <td style="width:12%">
                                            <div v-if="item.id" class="btnInline add-cart" @click="addCart(item)">
                                               <span class="iconfont icon-jiarugouwuche" title="加入购物车">添加至购物车</span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="'购物车'"
            :visible.sync="dialogVisible"
            size="tiny"
            v-loading.body="infoload">
            <div class="cart-info">
                <div class="msgBox clearfix ">
                    <ul class="head">
                        <li>
                            <span style="width：20%;">序号</span>
                            <span style="width：20%;">图片</span>
                            <span style="width：20%;">商品名</span>
                            <span style="width：20%;">数量</span>
                            <span style="width：20%;">单价</span>
                        </li>
                    </ul>
                    <div class="goods-list" v-if="cartList.length">
                        <ul>
                            <li v-for="(item,index) in cartList" :key="index">
                                <span>{{index+1}}</span>
                                <span class="goods-img">
                                    <img :src="item.image" alt="">
                                </span>
                                <span>{{item.productName}}</span>
                                <span class="goods-count">
                                    <i class="iconfont icon-jianshao" @click="reduCount(item)"></i>
                                    <b>{{item.count}}</b>
                                    <i class="iconfont icon-tianjia-xue" @click="addCount(item)"></i>
                                </span>
                                <span>{{item.amount}}</span>
                            </li>
                        </ul>
                    </div>
                    <div style="text-align:center;padding:10px 0;" v-else>
                        暂无选购商品
                    </div>
                    <div style="margin-top:10px;">
                            <span style="color:red">请选择收货地址：</span>
                            <el-select v-model="addr" style="width:100%;margin-top:10px;">
                                <el-option
                                    v-for="item in addrList"
                                    :key="item.id"
                                    :label="item.address"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    <div class="total-money">
                        总金额：{{totalAmount}}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="dialogVisible=false" class="cancel">取消</button>
                <button type="button" @click="goSelPayType" class="save">结账</button>
            </span>
        </el-dialog>
        <el-dialog
        title="备注"
        :visible.sync="showNotice"
        width="30%"
        >
            <span style="margin-left:1%;">{{note}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showNotice = false">取 消</el-button>
                <el-button  @click="showNotice = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
        title="选择支付方式"
        :visible.sync="showPayType"
        width="30%"
        >
            <div class="pay-type">
                <ul>
                    <li>
                        <span class="wechat" @click="selPayType('wechat')">微信</span>
                    </li>
                    <li>
                        <span class="ali" @click="selPayType('ali')">支付宝</span>
                    </li>
                    <li>
                        <span class="other" @click="selPayType('other')">先下单后结账</span>
                    </li>
                </ul>
            </div>
        </el-dialog>
        <el-dialog
        title="支付二维码"
        :visible.sync="showPayCode"
        width="30%"
        >
            <div class="pay-code">
                <div class="pay-time">支付剩余时间:{{payOutTime}}</div>
                <!-- <img :src="payCode" alt=""> -->
                <div id="qrCode" v-if="showPayCode"></div>
            </div>
        </el-dialog>
        <div class="big-img" v-if="showBigImg" @click="showBigImg=false;">
            <div class="big-img-wrap">
                <img :src="bigImgUrl" alt="">
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {BASE_URL} from "./../../../urlConfig";
    export default{
        props: ['curStoreId'],
    	data () {
    		return {
                payOutTime:"",//支付剩余时间
                payCode:"",//支付二维码
                showPayCode:false,//是否显示支付二维码
                orderId:"",//订单id
                addrList:[],//收货地址列表
                userName:"",//当前登录名(手机号)
                addr:"",//收货地址
                showPayType:false,
                totalAmount:0,//总金额
                showNotice:false,
                note:"",
                typeId:"",
                showBigImg:false,
                bigImgUrl:'',
                checkeds:false,
                dialogVisible: false,
                
                vipData:[],//所有商品列表
                goodsNum:{
                    pageNum:1,
                    pageSize:6,
                    total:0
                },
                infoload: false, // loading
                fliter_type: '', // 当前筛选条件
                typeList:[],
                cartList:[],//购物车列表
                seledGoodCount:0,
    		}
    	},
        watch:{
            showPayCode(val){
                if(!val){
                    clearInterval(this.countTimer);
                }
            },
            
            goods : function(val){
                if(val){
                    this.searchGoods(val,null)
                }else {
                    this.goodCheckArr = [];
                    this.getGoodsData();
                }
            }, 
            'newGoods.name' : function(val){
                if(val){
                    if(this.isAutoSearchBtn){
                        this.searchGoods(val,'9f5afd60-e952-11e7-a26a-83436326b6c5');
                    }else {
                        
                    }
                }else {
                    this.addGoodCheckArr = [];
                    // this.getGoodsData();
                }
            },
            timeChoice(val){
                if(val==''){
                    return;
                }
                if(this.newTimeList.length>=3){
                    this.$message({
                        message: '最多只能添加3个时间段',
                        customClass: 'error'
                    })
                    this.timeChoice = '';
                    return;
                }
                for (var i = 0; i < this.timeList.length; i++) {
                    if(val == this.timeList[i].id){
                        
                        let isPush = true;
                        for(var j=0;j<this.newTimeList.length;j++){
                            if(this.newTimeList[j].id == val){
                                isPush = false;
                                this.$message({
                                    message: '已经有该时段',
                                    customClass: 'error'
                                })
                            }
                        }
                        if(isPush){
                            this.newTimeList.push(this.timeList[i]); 
                        }
                    }
                }
                this.timeChoiceBtn = false;
                this.timeChoice = '';
            }  
        },
        methods: {
            getAddress(){
                //获取地址列表
                this.$http({
                    url:BASE_URL+"info-list",
                    method:"GET",
                    params:{
                        userName : this.userName
                    }
                }).then((res)=>{
                    this.addrList = res.data;
                })
            },
            selPayType(type){
                if(!this.orderId){
                    this.$message({
                        message: '请重新操作',
                        customClass: 'error'
                    });
                    return;
                }
                let data;
                if(type=="ali"||type=="wechat"){
                    data={
                        orderId:this.orderId,
                        type:type=="ali"?true:false,
                        source:"PAY",
                    }
                }else{
                    data={
                        orderId:this.orderId,
                        source:"UNPAY",
                    }
                }
                this.$http({
                    url:BASE_URL+"pay",
                    method:"POST",
                    data
                }).then(res=>{
                    if(type=="other"){
                        this.$confirm('确认提交此订单？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            setTimeout(()=>{
                                window.location.reload(true);
                            },500);
                            this.$message({
                                message: '提交成功',
                                customClass: 'success'
                            });
                            return;
                        })
                    }else{
                        this.showPayCode = true;
                        this.showPayType = false;
                        // this.payCode = res.data.url;
                        // 
                        setTimeout(()=>{
                            let qrcode = new QRCode("qrCode", {
                                text:res.data.url,
                                colorDark : "#000000",
                                colorLight : "#ffffff",
                                correctLevel : QRCode.CorrectLevel.H
                            });
                        },100);
                        // 
                        this.clearPayTime();
                    }
                    
                })
            },
            // 
            clearPayTime(){
                let maxTime = 60 * 3;//三分钟
                let nowCountTime;
                this.countTimer = setInterval(() => {
                    if (maxTime >= 0) {
                        let minutes = Math.floor(maxTime / 60);
                        let seconds = Math.floor(maxTime % 60);
                        seconds = seconds < 10 ? "0" + seconds : seconds;
                        nowCountTime = `${minutes}分${seconds}秒`;
                        this.payOutTime = nowCountTime;
                        --maxTime;
                        this.runPay();
                    } else {
                        clearInterval(this.countTimer);
                        this.payOutTime = "3分00秒";
                        this.showPayCode = false;
                    }
                }, 1000);
            },
            // 支付轮训
            runPay(){
                this.$http({
                    url:BASE_URL+"order-one",
                    method:"GET",
                    params:{
                        orderId:this.orderId
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        this.$message({
                            message: '支付成功',
                            customClass: 'success'
                        });
                        clearInterval(this.countTimer);
                        // this.payOutTime = "3分00秒";
                        // this.showPayCode = false;
                        // this.dialogVisible = false;
                        // this.cartList = [];
                        // this.orderId = "";
                        setTimeout(()=>{
                            window.location.reload(true);
                        },500);
                        return;
                    }
                })
            },
            goSelPayType(){
                if(this.cartList.length==0){
                    this.$message({
                        message: '请先选择商品',
                        customClass: 'error'
                    });
                    return;
                }
                if(!this.addr){
                    this.$message({
                        message: '请选择收货地址',
                        customClass: 'error'
                    });
                    return;
                }
                let addressObj = {};
                for(let i=0;i<this.addrList.length;i++){
                    if(this.addrList[i].id == this.addr){
                        addressObj = this.addrList[i];
                    }
                }
                console.log(this.cartList);
                let items = []
                for(let j=0;j<this.cartList.length;j++){
                    let obj = {
                        productId:this.cartList[j].id,
                        qty:this.cartList[j].count,
                        spec:this.cartList[j].spec,
                        amount:Number(this.cartList[j].amount)*Number(this.cartList[j].count),
                        productName:this.cartList[j].productName,
                        productTypeId:this.cartList[j].productTypeId,
                        typeName:this.cartList[j].productTypeName,
                    }
                    items.push(obj);
                }
                // let orderId = this.$uuid.create(1).hex;
                // this.orderId = orderId;
                this.$http({
                    url:BASE_URL+"shop-order",
                    method:"POST",
                    data:{
                        // id:orderId,
                        count:this.seledGoodCount,
                        amount:this.totalAmount,
                        address:addressObj.address,
                        mobile:addressObj.mobile,
                        name:addressObj.name,
                        orderUserName:this.userName,
                        items
                    }
                }).then(res=>{
                    if(res.data.result.code == 200){
                        // this.$message({
                        //     message: res.data.result.msg,
                        //     customClass: 'success'
                        // });
                        this.orderId = res.data.data.id;
                        this.showPayType = true;
                    }else{
                        this.$message({
                            message: res.data.result.msg,
                            customClass: 'error'
                        });
                    }
                    
                })
            },
            notice(item){
                this.note = item.notice;
                this.showNotice = true;
            },
            reduCount(item){
                if(item.count==1){
                    for(let i=0;i<this.cartList.length;i++){
                        if(this.cartList[i].id == item.id){
                            this.cartList.splice(i,1);
                        }
                    }
                    if(this.cartList.length == 0){
                        this.seledGoodCount = 0;
                        this.totalAmount=0;
                        return;
                    }
                }
                item.count--;
                this.seledGoodCount--;
                let totalAmount = this.totalAmount;
                totalAmount = Number(totalAmount)-Number(item.amount);
                this.totalAmount = Number(totalAmount).toFixed(2);
            },
            addCount(item){
                item.count++;
                this.seledGoodCount++;
                let totalAmount = this.totalAmount;
                totalAmount = Number(totalAmount)+Number(item.amount);
                this.totalAmount = Number(totalAmount).toFixed(2);
            },
            addCart(item){
                // console.log(item.count);
                let seledCount = 0;
                let itemStr = JSON.stringify(item);
                this.cartList.push(JSON.parse(itemStr));

                for(let i=0;i<this.cartList.length;i++){
                    seledCount += Number(this.cartList[i].count);
                }

                this.seledGoodCount = seledCount;
                // this.initOrderInfo();
            },
            bigImg(item){
                this.showBigImg = true;
                this.bigImgUrl = item.image;
            },
       
            addGoods(){
                //点击添加商品，清空 newGoods并获取获取商品分类
                this.dialogVisible = true;
                this.initOrderInfo();
            },
            initOrderInfo(){
                let cartObj = {};
                let totalAmount = 0;
                for(let i=0;i<this.cartList.length;i++){
                    if(!cartObj[this.cartList[i].id]){
                        cartObj[this.cartList[i].id] = this.cartList[i];
                    }else{
                        let nowItemCount = cartObj[this.cartList[i].id].count;
                        nowItemCount = Number(nowItemCount)+Number(this.cartList[i].count);
                        cartObj[this.cartList[i].id].count = Number(nowItemCount);
                    }
                }
                let newCartList = [];
                for(let key in cartObj){
                    newCartList.push(cartObj[key]);
                }
                this.cartList = newCartList;
                for(let j=0;j<newCartList.length;j++){
                    totalAmount+=Number(newCartList[j].amount)*Number(newCartList[j].count);
                }
                this.totalAmount = Number(totalAmount).toFixed(2);
            },
            // 筛选商品
            fliterGoods () {
                this.typeId = this.fliter_type;
                this.getGoodsData();
            },
            getGoodsData(){
                // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
                this.$http({
                    url: BASE_URL + "pro-list",
                    method: "GET",
                    params: {
                        type: this.typeId ? this.typeId : 0
                    }
                }).then((res)=>{
                    for(let i=0;i<res.data.length;i++){
                        res.data[i].count = 1;
                    }
                    this.vipData = res.data;
                    this.goodsNum.total = res.data.length;
                    if( this.vipData.length < 6 ){
                        for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
        },
        activated: function () {
            for (let i = 0; i < 6; i++) {
                this.vipData.push({});
            }
            this.$http({
                url: BASE_URL + "type-list",
                method: "GET",
                params: {}
            }).then((res)=>{
                this.typeList = res.data;
            })
            this.userName = localStorage.getItem("username");
            this.getGoodsData();
            this.getAddress();
        },
        mounted() {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
                $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import '../../tableTemplate/tableTem.scss';
	@import "./market.scss";
</style>



// WEBPACK FOOTER //
// market.vue?47ba977c